package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.model.ProviderPublicPlan
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import kotlinx.coroutines.flow.Flow

class ListPublicPlansUseCase(
    private val repository: ProviderPublicPlanRepository,
) {
    suspend operator fun invoke(): Result<Flow<List<ProviderPublicPlan>>> = runCatching {
        repository.list()
    }
}
